var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.65918 7.5C6.65918 6.80964 7.21882 6.25 7.90918 6.25C8.59954 6.25 9.15918 6.80964 9.15918 7.5C9.15918 8.19036 8.59954 8.75 7.90918 8.75C7.21882 8.75 6.65918 8.19036 6.65918 7.5Z",
    fill: "#240C0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.65918 3.125C6.65918 2.43464 7.21882 1.875 7.90918 1.875C8.59954 1.875 9.15918 2.43464 9.15918 3.125C9.15918 3.81536 8.59954 4.375 7.90918 4.375C7.21882 4.375 6.65918 3.81536 6.65918 3.125Z",
    fill: "#240C0C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.65918 11.875C6.65918 11.1846 7.21882 10.625 7.90918 10.625C8.59954 10.625 9.15918 11.1846 9.15918 11.875C9.15918 12.5654 8.59954 13.125 7.90918 13.125C7.21882 13.125 6.65918 12.5654 6.65918 11.875Z",
    fill: "#240C0C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/Dots.c9ca24181905a39cdae35415a9c92215.svg";
export { ForwardRef as ReactComponent };